import { useState } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useFetch } from "../../core/hooks/useFetch";
import { IFiltro } from "../../core/interfaces/IFiltro";
import { IDadosPaginacaoContas } from "../interfaces/IDadosPaginacaoContas";

export const useFetchContas = () => {
    const [paginaAtual, setPaginaAtual] = useState(1);
    const urlInicial = `/contas/manuais?paginaAtual=1`;
    const [url, setUrl] = useState<string>(urlInicial);
    const { data: dados, error, isLoading, mutate } = useFetch<IDadosPaginacaoContas>(ApiFactory.getApi("MS_FINANCEIRO"), url);

    const handlePaginaChange = (event: unknown, newPage: number) => {
        setUrl(url.replace(/(paginaAtual=)\d+/, `paginaAtual=${newPage}`));
        setPaginaAtual(newPage);
    }

    const filtrar = (filtros: IFiltro[]) => {
        let filtrosUrl = urlInicial;

        filtros.map(filtro => {
            filtrosUrl = `${filtrosUrl}&${filtro.chave}=${filtro.valor}`;
        })

        setUrl(filtrosUrl);
        setPaginaAtual(1);
    }

    const limpar = () => {
        setUrl(urlInicial);
        setPaginaAtual(1);
    }

    return { dados, error, isLoading, mutate, handlePaginaChange, filtrar, limpar }
}
